module.exports = __webpack_public_path__ + "img/mission-icon-27.00bf7cd7.png";